<nz-modal
	[(nzVisible)]="deleteOneModal"
	(nzOnCancel)="deleteOneModal = false"
	(nzOnOk)="removeOne()"
	[nzTitle]="'common_deletion' | translate"
	[nzContent]="'common_delete-one' | translate"
	[nzOkLoading]="deleting"
></nz-modal>
<nz-modal
	[(nzVisible)]="deleteManyModal"
	(nzOnCancel)="deleteManyModal = false"
	(nzOnOk)="removeMany()"
	[nzTitle]="'common_deletion' | translate"
	[nzContent]="'common_delete-many' | translate"
	[nzOkLoading]="deleting"
></nz-modal>
<div class="role-permission-list-container">
	<nz-table
		#table
		[nzData]="items"
		[nzSize]="'small'"
		[nzShowSizeChanger]="true"
		[nzFrontPagination]="false"
		[nzLoading]="refreshing"
		[nzLoadingDelay]="refreshingDelay"
		[nzTotal]="total"
		[nzNoResult]="notFound"
		[(nzPageIndex)]="pageIndex"
		[(nzPageSize)]="searchParams.props._limit"
		(nzPageIndexChange)="update()"
		(nzPageSizeChange)="update(true)"
	>
		<thead (nzSortOrderChange)="sort($event)">
			<tr>
				<th *ngIf="enableMultiSelect">
					<button
						(click)="deleteManyModal = true"
						nz-button
						[disabled]="selectedRows.length === 0"
						nzType="default"
						nzShape="circle"
					>
						<i nz-icon nzType="delete"></i>
					</button>
				</th>
				<th
					*ngIf="columns.includes('created_at')"
					nzColumnKey="created_at"
					[nzSortOrder]="getSortOrder('created_at')"
				>
					{{ 'role-permission_created-at' | translate }}
				</th>
				<th
					*ngIf="columns.includes('collection')"
					nzColumnKey="collection"
					[nzSortOrder]="getSortOrder('collection')"
				>
					{{ 'role-permission_collection' | translate }}
				</th>
				<th
					*ngIf="columns.includes('create')"
					nzColumnKey="create"
					[nzSortOrder]="getSortOrder('create')"
				>
					{{ 'role-permission_create' | translate }}
				</th>
				<th
					*ngIf="columns.includes('read')"
					nzColumnKey="read"
					[nzSortOrder]="getSortOrder('read')"
				>
					{{ 'role-permission_read' | translate }}
				</th>
				<th
					*ngIf="columns.includes('update')"
					nzColumnKey="update"
					[nzSortOrder]="getSortOrder('update')"
				>
					{{ 'role-permission_update' | translate }}
				</th>
				<th
					*ngIf="columns.includes('delete')"
					nzColumnKey="delete"
					[nzSortOrder]="getSortOrder('delete')"
				>
					{{ 'role-permission_delete' | translate }}
				</th>
				<th
					*ngIf="columns.includes('search')"
					nzColumnKey="search"
					[nzSortOrder]="getSortOrder('search')"
				>
					{{ 'role-permission_search' | translate }}
				</th>
				<th
					*ngIf="columns.includes('count')"
					nzColumnKey="count"
					[nzSortOrder]="getSortOrder('count')"
				>
					{{ 'role-permission_count' | translate }}
				</th>
				<th *ngIf="showActions" class="actions-cell">
					{{ 'common_actions' | translate }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let row of table.data" (click)="onClick(row)">
				<td
					*ngIf="enableMultiSelect"
					nzShowCheckbox
					(nzCheckedChange)="selectRow($event, row)"
					[nzChecked]="isSelected(row)"
				></td>
				<td *ngIf="columns.includes('created_at')">
					{{ row.props.created_at | date: 'medium' }}
				</td>
				<td *ngIf="columns.includes('collection')">
					{{ row.props.collection }}
				</td>
				<td *ngIf="columns.includes('create')">
					{{
						(row.props.create ? 'common_true' : 'common_false')
							| translate
					}}
				</td>
				<td *ngIf="columns.includes('read')">
					{{
						(row.props.read ? 'common_true' : 'common_false')
							| translate
					}}
				</td>
				<td *ngIf="columns.includes('update')">
					{{
						(row.props.update ? 'common_true' : 'common_false')
							| translate
					}}
				</td>
				<td *ngIf="columns.includes('delete')">
					{{
						(row.props.delete ? 'common_true' : 'common_false')
							| translate
					}}
				</td>
				<td *ngIf="columns.includes('search')">
					{{
						(row.props.search ? 'common_true' : 'common_false')
							| translate
					}}
				</td>
				<td *ngIf="columns.includes('count')">
					{{
						(row.props.count ? 'common_true' : 'common_false')
							| translate
					}}
				</td>
				<td *ngIf="showActions" class="actions-cell">
					<button
						(click)="
							rowToDelete = row;
							deleteOneModal = true;
							$event.stopPropagation()
						"
						nz-button
						nzType="default"
						nzShape="circle"
						[title]="'playlist-table_delete-button' | translate"
						class="ml-3"
					>
						<i nz-icon nzType="delete"></i>
					</button>
				</td>
			</tr>
		</tbody>
	</nz-table>
	<ng-template #notFound>
		<nz-empty
			[nzNotFoundContent]="'role-permission_common_not-found' | translate"
		></nz-empty>
	</ng-template>
</div>
